import React, { Component } from "react";
import { Ebrochure as EbrochureDefault } from "../common";

export default class Ebrochure extends Component {
  render() {
    return <EbrochureDefault {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketLagunaVillageResidences/Ebrochure.js